import { render } from "./email-verification-two.vue?vue&type=template&id=9919b6bc"
import script from "./email-verification-two.vue?vue&type=script&lang=js"
export * from "./email-verification-two.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__